import storeManager from '../../store/StoreManager';
import { updateCurrentSlideMoods } from '../../actions/CurrentSlideActions';
import { updateProductionMoods } from '../../actions/ProductionActions';
import modeType from '../../constants/ModeConstants';

const moodsUtils = {
    moods: [],
    clipartModel: undefined,

    addMood(logicalName, moods) {
        this.moods[logicalName] = moods;
    },
    getMoods(logicalName) {
        return this.moods[logicalName];
    },
    updateProductionMoods() {
        const dispatch = storeManager.getStore().dispatch;

        dispatch(updateProductionMoods());
        dispatch(updateCurrentSlideMoods());
    },

    previewContextMenu: modeType.CONTEXT_NONE
};

export default moodsUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/MoodsUtils.js
 **/